import { FormControl, InputLabel, Select } from "@material-ui/core";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { Fragment } from "react";
import { Button, Col, Form, Image, Modal, Row, Table } from "react-bootstrap";
import Scrollbars from "react-custom-scrollbars";
import Media from "react-media";
import { connect, useDispatch } from "react-redux";
import { NavLink, useHistory } from "react-router-dom";
import Alert from "react-s-alert";
import {
  CATALOG_SELECTED_CATEGORIES_ITEMS,
  SELECTED_CATALOG_ITEMS,
  SELECTED_ITEMS_ID,
} from "../../../../../../../../store/types";
import { MobileTopHeader } from "../../../../../../../reusableComponents/sliderReusableComponent/MobileTopHeader";
import { BackLogoIconButton } from "../../../../../../../reusableComponents/smallReusableComponent/LoginTopLogoAndText";
import { TopTextReusableComponent } from "../../../../../../reusableOnboardingComponent/TopTextReusable/TopTextReusableComponent";
import {
  vendor_show_local_menu_category,
  vendor_create_local_catalog_global,
} from "../../../../../../../../store/actions/VendorSubscriptionAction/vendorSubscriptionGetAction";
import Items from "../../../../../../../vendorDashboardComponents/reviewsVendors/VendorRatingReviewInsidePages/Items";

const SelectItemsNew = (props) => {

  console.log("props",props)
  //   const [nextStepModal, setNextStepModal] = useState(false);
  //   const handleCloseZNextStepModal = () => {
  //     setNextStepModal(false);
  //   };
  //   const handleShowZNextStepModal = () => {
  //     setNextStepModal(true);
  //   };
  //   const onWithOutApiCall = (e) => {
  //     props.history.push({
  //       pathname: "/casual-fine-dining/menusetup/selectmenu/selecteditems",
  //     });
  //   };
  //   const [globalActiveId, setGlobalActiveId] = useState();
  //   const [globalMenu, setGlobalMenu] = useState([
  //     { id: 1, name: "Arabic", active: false },
  //     { id: 2, name: "Chinese", active: false },
  //     { id: 3, name: "Sindhi", active: false },
  //   ]);

  //   const category = [
  //     {
  //       id: 1,
  //       categories: [
  //         {
  //           id: "5001",
  //           type: "Desserts",
  //           active: false,
  //           items: [
  //             {
  //               itemId: 41,
  //               itemName: "Italian Pizza",
  //               description: "Tomato fillet, basil olive oil",
  //             },
  //             {
  //               itemId: 42,
  //               itemName: "American Pizza",
  //               description: "Onions fillet, Paneer ",
  //             },
  //           ],
  //         },
  //         { id: "5002", type: "Beverages", active: false },
  //         { id: "5003", type: "Starters", active: false },
  //       ],
  //     },
  //     {
  //       id: 2,
  //       categories: [
  //         { id: "5001", type: "Soup", active: false },
  //         { id: "5002", type: "Starters", active: false },
  //       ],
  //     },
  //   ];

  //   const [activeCategory, setActiveCategory] = useState([]);
  //   const [activeCategoryId, setActiveCategoryId] = useState(0);
  //   const [activeItems, setActiveItems] = useState([]);

  //   const changeActiveStatus = (id) => {
  //     let updateStatus = globalMenu.map((item) => {
  //       if (item.id === id) {
  //         return { ...item, active: true };
  //       } else {
  //         return { ...item, active: false };
  //       }
  //     });
  //     setGlobalActiveId(id);
  //     setGlobalMenu(updateStatus);
  //     let tempCategory = [];
  //     category.map((item) => {
  //       if (item.id === id) {
  //         tempCategory = item.categories;
  //       }
  //     });
  //     setActiveCategory(tempCategory);
  //   };

  //   const getItemsFromCategory = (catalogId) => {
  //     category.map((item) => {
  //       if (item.id === globalActiveId) {
  //         for (var i = 0; i < item.categories.length; i++) {
  //           if (item.categories[i].id === catalogId) {
  //             setActiveCategoryId(item.categories[i].id);
  //             if (
  //               item.categories[i] &&
  //               item.categories[i].items &&
  //               item.categories[i].items.length > 0
  //             ) {
  //               setActiveItems(item.categories[i].items);
  //             } else {
  //               setActiveItems([]);
  //             }
  //           }
  //         }
  //       }
  //     });
  //   };

  //   const [state, setState] = useState({ global: "Arabic", catalog: "" });
  //   const handleChangeCategory = (e) => {
  //     setState({ global: "", catalog: "" });
  //     setActiveCategory({ activeCategory: state.global });
  //   };
  let history = useHistory();
  const [loading, setLoading] = useState(false);
  const [nextStepModal, setNextStepModal] = useState(false);
  const handleCloseZNextStepModal = () => {
    setNextStepModal(false);
  };
  const dispatch = useDispatch();
  const handleShowZNextStepModal = () => {
    // props.history.push({
    //   pathname: "/superadmin-global-catalogue/catalogue",
    // });
    //

    const prepareData = {};
    prepareData.category = [];
    prepareData.items = [];
    let categoryId = [];
    let itemArrayToDispatch = [];

    let checkedArray = [];
    for (let i = 0; i < actualMenuData.length; i++) {
      if (!categoryId.includes(actualMenuData[i]._id)) {
        categoryId.push(actualMenuData[i]._id);
        prepareData.category.push({
          categoryId: actualMenuData[i]._id,
          is_temp_local: false,
        });
      }
      for (let j = 0; j < actualMenuData[i].items.length; j++) {
        if (actualMenuData[i].items[j].checked) {
          checkedArray.push(actualMenuData[i].items[j]._id);
          let tempData = { ...actualMenuData[i].items[j] };
          tempData.categoryName = actualMenuData[i].name;
          itemArrayToDispatch.push(tempData);
          tempData = {};
          prepareData.items.push({
            itemId: actualMenuData[i].items[j]._id,
            is_temp_local: false,
          });
        } else {
          prepareData.items.push({
            itemId: actualMenuData[i].items[j]._id,
            is_temp_local: true,
          });
        }
      }
    }

    if (checkedArray.length === 0) {
      Alert.error(`<h4>Please select atleast one item too proceed </h4>`, {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      });
    } else {
      const formData = {};
      formData.items = checkedArray;
      dispatch({ type: SELECTED_CATALOG_ITEMS, payload: itemArrayToDispatch });
      dispatch({ type: SELECTED_ITEMS_ID, payload: checkedArray });
      dispatch({
        type: CATALOG_SELECTED_CATEGORIES_ITEMS,
        payload: prepareData,
      });

      if (props.dash) {
        history.push("/selecteditemsnew");
      } else {
        history.push(
          "/casual-fine-dining/menusetup/selectmenu/selecteditemsnew"
        );
      }
      //setNextStepModal(true);
    }
  };
  const onWithOutApiCall = (e) => {
    props.history.push({
      pathname: "/superadmin-global-catalogue/catalogue",
    });
  };
  const [globalActiveId, setGlobalActiveId] = useState();
  const [globalMenu, setGlobalMenu] = useState([
    // { id: 1, name: "Arabic", active: true },
    // { id: 2, name: "Chinese", active: false },
    // { id: 3, name: "Sindhi", active: false },
  ]);
  console.log("global menu",globalMenu)
  console.log("globalActID",globalActiveId)
  const category = [
    {
      id: 1,
      categories: [
        {
          id: "5001",
          type: "Desserts",
          active: true,
          items: [
            {
              itemId: 41,
              itemName: "Italian Pizza",
              description: "Tomato fillet, basil olive oil",
            },
            {
              itemId: 42,
              itemName: "American Pizza",
              description: "Onions fillet, Paneer ",
            },
          ],
        },
        { id: "5002", type: "Beverages", active: false },
        { id: "5003", type: "Starters", active: false },
      ],
    },
    {
      id: 2,
      categories: [
        { id: "5001", type: "Soup", active: false },
        { id: "5002", type: "Starters", active: false },
      ],
    },
  ];

  const [activeCategory, setActiveCategory] = useState([]);
  const [activeCategoryId, setActiveCategoryId] = useState("");
  const [activeItems, setActiveItems] = useState([]);
  console.log("activeItems",activeItems)
  console.log("activeCategory",activeCategory)
  console.log("activeCategoryId",activeCategoryId)
  const changeActiveStatus = (id) => {
    let updateStatus = globalMenu.map((item) => {
      if (item.id === id) {
        return { ...item, active: true };
      } else {
        return { ...item, active: false };
      }  
    });
    console.log("updateStatus",updateStatus)
    console.log("id",id)

    setGlobalActiveId(id);
    setGlobalMenu(updateStatus);
    let tempCategory = [];
    category.map((item) => {
      if (item.id === id) {
        tempCategory = item.categories;
      }
    });
    setActiveCategory(tempCategory);
  };

  // const setItemsForCategory = (items, categoryId) => {
  //   // category.map((item) => {
  //   //   if (item.id === globalActiveId) {
  //   //     for (var i = 0; i < item.categories.length; i++) {
  //   //       if (item.categories[i].id === catalogId) {
  //   //         setActiveCategoryId(item.categories[i].id);
  //   //         if (
  //   //           item.categories[i] &&
  //   //           item.categories[i].items &&
  //   //           item.categories[i].items.length > 0
  //   //         ) {
  //   //           setActiveItems(item.categories[i].items);
  //   //         } else {
  //   //           setActiveItems([]);
  //   //         }
  //   //       }
  //   //     }
  //   //   }
  //   // });
  //  console.log(items, categoryId);
  //   setActiveCategoryId(categoryId);
  //   setActiveItems(items);
  // };
  const setItemsForCategory = (items, categoryId) => {
    console.log(items, categoryId);
  
    if (items && items.length > 0) {
      setActiveCategoryId(categoryId);
      setActiveItems(items);
    } else {
      console.log("No data available.");
      setActiveCategoryId("");
      setActiveItems([]);
   }
  };

  const [state, setState] = useState({ global: "Arabic", catalog: "" });
  const handleChangeCategory = (e) => {
    setState({ global: "", catalog: "" });
    setActiveCategory(state.global);
  };

  const [actualMenuData, setActualMenuData] = useState([]);
  console.log("actualMenuData",actualMenuData)
  const addCheck = (status, itemId) => {
    let updatedData = [...actualMenuData];
    for (let i = 0; i < updatedData.length; i++) {
      for (let j = 0; j < updatedData[i].items.length; j++) {
        if (itemId === updatedData[i].items[j]._id) {
          if (status !== undefined && status !== null) {
            updatedData[i].items[j].checked = !status;
          } else {
            updatedData[i].items[j].checked = true;
          }
        }
      }
    }
    setActualMenuData(updatedData);
  };

  const onSuccess = () => {
    setLoading(false);
  };

  //   useEffect(() => {
  //     setLoading(true);
  //     const token = props.auth.user.accessToken;
  //     props.admin_get_category_menu_setup(token, onSuccess);
  //   }, []);

  useEffect(() => {
    const token = props.auth.user.accessToken;
    const vendorId = props.auth.user.VendorUser._id;
     let isMounted = true;

    // return () => {
    //   isMounted = false;
    // }; 

    props.vendor_show_local_menu_category(
      token,
      vendorId,
      props.selectedCatalogId,
      (data) =>{
        if (isMounted){
          onSuccessVendorShowLocalMenu(data)
        };
      } 
    );
  }, [props.auth.user.accessToken, props.auth.user.VendorUser._id, props.selectedCatalogId]);

  const onSuccessVendorShowLocalMenu = (data) => {
    setItemsForCategory(data && data[0]?.items, data && data[0]?._id);
  };

  useEffect(() => {
    setGlobalMenu([
      {
        id: 1,
        name: props && props.activeCatalogName,
        active: true,
      },
    ]);
  }, [props.activeCatalogName]);
  useEffect(() => {
    console.log("activeCategoryId", activeCategoryId);
    console.log("activeItems", activeItems);
  }, [activeCategoryId, activeItems]);

  

  useEffect(() => {
    // if (Object.entries(props.active_global_catalog).length !== 0) {

    // let itemsId = [];
    // // for (let i = 0; i < props.active_global_catalog.items.length; i++) {
    // //   itemsId.push(props.active_global_catalog.items[i]._id);
    // // }
    // let menuData = [];
    // for (let j = 0; j < props.all_local_catalog.length; j++) {
    //   //menuData.push(props.all_local_catalog[i])
    //   let menu = JSON.parse(JSON.stringify(props.all_local_catalog[j]));
    //   menu.items = [];
    //   for (let k = 0; k < props.all_local_catalog[j].items.length; k++) {
    //     if (itemsId.includes(props.all_local_catalog[j].items[k]._id)) {
    //       let tempItem = JSON.parse(
    //         JSON.stringify(props.all_local_catalog[j].items[k])
    //       );
    //       tempItem.checked = true;
    //       menu.items.push(tempItem);
    //     } else {
    //       menu.items.push(props.all_local_catalog[j].items[k]);
    //     }
    //   }
    //   menuData.push(menu);
    // }

    setActualMenuData(props.all_local_catalog);
    // }
    // } else {
    //   props.history.push({
    //     pathname: `/superadmin-global-catalogue/`,
    //   });
    // }
  }, [props.all_local_catalog]);
  const mainDisplay = () => {
    return (
      <div
        className={`${!props.dash && `onboarding_process_screen-button-map`}`}
      >
        <Row className="align-items-center">
          <Col lg={12} className="pl-lg-0">
            <div className="mb-4">
              <TopTextReusableComponent
                headingText="Select Items"
                headingParagraph="(Select the items from the categories and cuisines selected before that you want to provide from this catalogue"
              />
            </div>
          </Col>
          <Col lg={5} className="pl-lg-0">
            <Form.Control
              type="text"
              placeholder="Search"
              className="amSearch"
              style={{ backgroundColor: "#fff" }}
            />
          </Col>
          <Media query="(min-width: 992px)">
            <Col lg={7} className="text-right">
              <Button
                variant="danger"
                className="btn150px btn-lg px-5"
                onClick={() => handleShowZNextStepModal()}
              >
                Proceed
              </Button>
            </Col>
          </Media>
        </Row>
        <Row>
          <Media query="(min-width: 992px)">
            <Col lg={5} className="pl-md-0">
              <Row>
                <Col md={6} className="pr-md-1">
                  <div className="bg-white enP075rem f16-500">
                    Global Catalogue
                  </div>
                  <Scrollbars style={{ width: "100%", height: 500 }}>
                    <div className="enCategoryList h-100 p-1">
                      {globalMenu.map((global, index) => (
                        <button
                          type="button"
                          className={`f14-400 ${global.active ? "active" : ""}`}
                          key={index}
                          onClick={() => changeActiveStatus(global.id)}
                        >
                          {global.name}
                        </button>
                      ))}

                      {/* <button type="button" className={`f14-400 `}>
                  Chinese
                </button>
                <button type="button" className={`f14-400 `}>
                  Sindhi
                </button> */}
                    </div>
                  </Scrollbars>
                </Col>
                <Col md={6} className="pl-md-0">
                  <div className="bg-white enP075rem f16-500">Categories</div>
                  <Scrollbars style={{ width: "100%", height: 500 }}>
                    <div className="enCategoryList h-100 p-1">
                      {actualMenuData.map((category, index) => (
                        <button
                          type="button"
                          className={`f14-400 ${
                            activeCategoryId === category?._id ? "active" : ""
                          }`}
                          key={index}
                          onClick={() =>
                            setItemsForCategory(category?.items, category?._id)
                          }
                        // onClick={() => getItemsFromCategory(catalog.id)}
                        >
                          {category.name}
                        </button>
                      ))}

                      {/* <button type="button" className={`f14-400 `}>
                  Beverages
                </button>
                <button type="button" className={`f14-400 `}>
                  Startters
                </button> */}
                    </div>
                  </Scrollbars>
                </Col>
              </Row>
            </Col>
          </Media>
          <Media query="(max-width: 991px)">
            <Col xs={12} className="pt-3">
              <Row>
                <Col xs={6}>
                  <FormControl variant="outlined" className={"w-100"}>
                    <InputLabel htmlFor="outlined-GlobalCatalogue">
                      Global Catalogue
                    </InputLabel>
                    <Select
                      value={globalActiveId}
                      id="GlobalCatalogue"
                      onChange={(e) => changeActiveStatus(e.target.value)}
                      // onChange={(e) => handleChangeCategory(e)}
                      label="Global Catalogue"
                      inputProps={{
                        name: "GlobalCatalogue",
                        id: "outlined-GlobalCatalogue",
                      }}
                      
                      IconComponent={KeyboardArrowDownIcon}
                    >
                      {globalMenu.map((global, index) => (
                        <option key={index} value={global.id}>
                          {global.name}
                        </option>
                      ))}
                    
                    </Select>
                  </FormControl>
                </Col>
                <Col xs={6}>
                  <FormControl variant="outlined" className={"w-100"}>
                    <InputLabel htmlFor="outlined-Categories">
                      Categories
                    </InputLabel>
                    <Select
                      value={activeCategoryId}
                      id="Categories"
                      onChange={(e) => {
                        var tempData = actualMenuData.filter((d) => {
                          return d._id === e.target.value;
                        });

                        if (tempData && tempData.length > 0) {
                          setItemsForCategory(
                            tempData[0]?.items,
                            tempData[0]?._id
                          );
                        }
                      }}
                      label="Categories"
                      inputProps={{
                        name: "Categories",
                        id: "outlined-Categories",
                      }}
                      IconComponent={KeyboardArrowDownIcon}
                    >
                      {actualMenuData.map((category, index) => (
                        <option key={index} value={category._id}>
                          {category.name}
                        </option>
                      ))}
                    </Select>
                  </FormControl>
                </Col>
              </Row>
            </Col>
          </Media>
          <Col lg={7} className="text-right pl-lg-0">
            <div className="user-table-reusable-superadmin table-responsive mobile_table">
              <Table className="enAuditLogTBL HideShowTable text-left">
                <thead>
                  <tr className="super_admin_all_users_table_head rounded-0">
                    <th className="f12-700" style={{ width: "20%" }}>
                      Item ID
                    </th>
                    <th className="f12-700" style={{ width: "20%" }}>
                      Item Name
                    </th>
                    <th className="f12-700" style={{ width: "40%" }}>
                      Description
                    </th>
                    <th className="f12-700" style={{ width: "20%" }}>
                      Select
                    </th>
                  </tr>
                </thead>
         {activeItems.length > 0 ? ( 
          <> 
                {activeItems.map((item, index) => (

                  <Fragment key={index}>
                    {item.status ? (
                      <tbody>
                        <tr className="super_admin_all_users_table_body">
                          <td style={{ width: "20%" }}>
                            <div className="f14-500 text-break">
                              #ID {item._id}
                            </div>
                            <div className="enIMG62 mt-2">
                              <Image
                                //src={require("../../../../../assets/images/UserManagement/items.png")}
                                src={item && item.images && item.images[0]}
                                alt="item img"
                                title="item img"
                                fluid
                                width="100%"
                                height="100%"
                              />
                            </div>
                          </td>
                          <td style={{ width: "20%" }}>
                            <div className="d-flex mt-2 align-items-center">
                              <Image
                                src={
                                  item && item.veg
                                    ? require("../../../../../../../../assets/images/superadmin/ordericon/veg.svg")
                                    : require("../../../../../../../../assets/images/superadmin/ordericon/non veg.svg")
                                }
                                //src={require("../../../../../assets/images/UserManagement/veg.svg")}
                                alt={`${item.veg ? "Veg" : "Non-Veg"}`}
                                title={`${item.veg ? "Veg" : "Non-Veg"}`}
                                fluid
                                width="16px"
                                className="vegIcon"
                              />
                              <div className="f14-500 pl-2 text-break">
                                {item.name}
                              </div>
                            </div>
                            <hr />
                            <div className="d-flex mt-2 align-items-center">
                              {/* <Image
                              src={require("../../../../../assets/images/UserManagement/vegan.svg")}
                              alt="Vegan"
                              title="Vegan"
                              fluid
                              width="16px"
                              className="vegIcon"
                            /> */}
                              <div className="f14-500 pl-2">
                                {" "}
                                {item &&
                                  item.primary_food_type &&
                                  item.primary_food_type.title}
                              </div>
                            </div>
                          </td>
                          <td style={{ width: "45%" }}>
                            <div className="f14-500">{item.description}</div>
                          </td>
                          <td style={{ width: "15%" }}>
                            <Form.Check
                              checked={item.checked}
                              label="1"
                              inline
                              className="enCheckBoxOnly"
                              onClick={() => addCheck(item.checked, item._id)}
                            />
                          </td>
                        </tr>
                      </tbody>
                    ) : (
                      <>  </>
                    )}
                  </Fragment>
                ))}  </>
                ): ( <h4> No Data Found </h4>)}
              </Table>
            </div>
            <Media query="(max-width: 992px)">
              <Button
                variant="danger"
                className="w-100 btn-lg px-5"
                onClick={() => handleShowZNextStepModal()}
              >
                Proceed
              </Button>
            </Media>
            {/* <div className="fixed-bottom bg-white border-top p-2">
          <Button
            variant="danger"
            className="w-100 btn-lg px-5"
            onClick={handleShowZNextStepModal}
          >
            Proceed
          </Button>
        </div> */}
          </Col>
        </Row>
      </div>
    );
  };
  return (
    <React.Fragment>
      {props.dash? (
        mainDisplay()
      ) : (
        <div className="container-fluid onboarding_process_screen_left">
          <div className="row">
            <Media query="(min-width: 992px)">
              <div className="col-6">
                <BackLogoIconButton
                  displayBackText={true}
                  displayArrow={true}
                  backButtonClicked={
                    "/casual-fine-dining/menusetup/selectmenu/selectedcategories"
                  }
                  notDisplaProgressBar={true}
                />
              </div>
            </Media>
            <Media query="(max-width: 991px)">
              <MobileTopHeader
                link={true}
                onLink={
                  "/casual-fine-dining/menusetup/selectmenu/selectedcategories"
                }
                notDisplaProgressBar={true}
              />
            </Media>

            <div className="col-6 loginsignup-rightside bg-transparent min-height-auto">
              <div className="row">
                <div className="col-12 login-section-one">
                  <div className="login-top-right-nav">
                    <NavLink to="/">
                      <i
                        className="fa fa-question-circle-o"
                        aria-hidden="true"
                      ></i>
                    </NavLink>
                  </div>
                  <div className="login-top-right-nav margin-hamburgur">
                    <NavLink to="/">
                      <i className="fa fa-bars" aria-hidden="true"></i>
                    </NavLink>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {mainDisplay()}
        </div>
      )}
      <Modal
        show={nextStepModal}
        onHide={handleCloseZNextStepModal}
        centered
        className="xl-width-750"
      >
        <Modal.Header className="px-4 border-0" closeButton>
          <div className="w-100">
            <Modal.Title className="f20-700 pb-2">Alert</Modal.Title>
            <div className="d-flex justify-content-between">
              <p className="f14-400">Please Select from below</p>
            </div>
          </div>
        </Modal.Header>
        <Modal.Body className="px-4">
          <Form>
            <label className="enRadioWithText f12-400 w-100 mb-3">
              Upload all the cuisines and categories without editing
              <input type="radio" name="CouponDiscountType" />
              <span class="checkmark"></span>
            </label>
            <label className="enRadioWithText f12-400 w-100">
              Edit all the categories one by one, before submitting
              <input type="radio" name="CouponDiscountType" />
              <span class="checkmark"></span>
            </label>
          </Form>
          <div className="d-flex align-items-center py-4">
            <Button
              variant="outline-secondary"
              className="btn150px btn-lg mr-4 px-5"
              onClick={handleCloseZNextStepModal}
            >
              Cancel
            </Button>
            <Button
              variant="danger"
              className="btn150px btn-lg px-5"
              onClick={onWithOutApiCall}
            >
              Proceed
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
};

SelectItemsNew.propTypes = {
  auth: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  all_local_catalog: state.onboarding.all_local_catalog,
  selectedCatalogId: state.onboarding.selectedCatalogId,
  activeCatalogName: state.onboarding.activeCatalogName,
});

export default connect(mapStateToProps, { vendor_show_local_menu_category })(
  SelectItemsNew
);
